import {
  Checkbox as MuiCheckbox,
  type Theme,
} from '@mui/material';

import {
  CheckboxCheckedIcon,
  CheckboxIcon,
  CheckboxIndeterminateIcon,
  checkboxStyles,
} from './Checkbox.styled.js';
import type { CheckboxProps } from './Checkbox.types.js';

export const Checkbox = (props: CheckboxProps) => {
  const disabledColor = (theme: Theme) => (props.disabled ? theme.palette.grey[500] : null);
  const normalColor = (theme: Theme) => (props.color ? theme.palette[props.color].main : theme.palette.primary.main);

  return (
    <MuiCheckbox
      sx={checkboxStyles}
      disableRipple
      checkedIcon={<CheckboxCheckedIcon colorFn={theme => disabledColor(theme) || normalColor(theme)} />}
      indeterminateIcon={
        <CheckboxIndeterminateIcon colorFn={theme => disabledColor(theme) || normalColor(theme)} />
      }
      icon={<CheckboxIcon />}
      {...props}
    />
  );
};
